export default __webpack_public_path__ + "static/media/Electrical Engineering.3f1036f9.pdf";